<!--<iframe title="PLAN MOVES" style="overflow:hidden;height:800px;width:100%" [src]="transformURL()" frameborder="0" allowFullScreen="true"></iframe>-->
<h3 class="text-center" style="color: #5A1727">{{tipoAyuda}}</h3>
<mat-horizontal-stepper linear #stepper>
    <!--<mat-step [stepControl]="documentos" [editable]="isEditable">
        <ng-template matStepLabel>Documentos</ng-template>
        <app-documentos [datoTramite]="datoTramite"></app-documentos>
      </mat-step>-->
  <mat-step [stepControl]="(datosCliente | async)" [editable]="isEditable">
    <ng-template matStepLabel>Cliente</ng-template>
    <app-cliente #clienteComponent (datoCliente)="siguiente2($event)"></app-cliente>
  </mat-step>
  <mat-step [stepControl]="datosAyuda" [editable]="isEditable">
    <ng-template matStepLabel>Datos ayuda</ng-template>
    <form [formGroup]="datosAyuda" autocomplete="off" (ngSubmit)="siguiente3($event)">
      <h3 class="text-left" style="color: #5A1727">Datos de la ayuda</h3>
      <hr>


      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12" *ngIf="!esReinicia">
        <mat-label>Tipo de ayuda:</mat-label>
        <select matNativeControl formControlName="tipoAyuda" (change)="setTipoAyuda()">
          <option value="PLAN MOVES III 2025 - ADQUISICION VEHICULO ELECTRICO">PLAN MOVES III 2025 - ADQUISICION VEHICULO ELECTRICO</option>
          <option value="PLAN MOVES III 2025 - INSTALACION PUNTO DE RECARGA">PLAN MOVES III 2025 - INSTALACION PUNTO DE RECARGA</option>
        </select>
      </mat-form-field>
        <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
          <mat-label>Tipo de Solicitante</mat-label>
          <select matInput matNativeControl formControlName="tipoSolicitante" (change)="mostrarCampos()">
            <option value="PARTICULAR ESPAÑOL">Particular Español</option>
            <option value="PARTICULAR EXTRANJERO">Particular Extranjero</option>
            <option value="PROFESIONAL AUTONOMO">Profesional Autónomo</option>
            <option value="SOCIEDAD ANONIMA">Sociedad Anónima</option>
            <option value="SOCIEDAD LIMITADA">Sociedad Limitada</option>
            <option value="COMUNIDAD DE BIENES">Comunidad de Bienes</option>
            <option value="COMUNIDAD DE PROPIETARIOS">Comunidad de Propietarios</option>
          </select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
          <mat-label>Tipo de Adquisición</mat-label>
          <select matNativeControl formControlName="tipoAdquisicion">
            <option value="DIRECTA">Directa</option>
            <option value="FINANCIACION BANCARIA" *ngIf="tipoAyuda=='AYUDA MOVES'">Financiación Bancaria</option>
            <option value="LEASING" *ngIf="tipoAyuda=='AYUDA MOVES'">Leasing</option>
            <option value="RENTING O LEASING CORPORATIVO" *ngIf="tipoAyuda=='AYUDA MOVES'">Renting o Leasing Operativo</option>
          </select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
            <mat-label>IBAN</mat-label>
            <input matInput matNativeControl type="text" maxlength="24" formControlName="IBAN">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="esReinicia">
          <mat-label>Número de expediente del consorcio de seguros</mat-label>
          <input matInput matNativeControl type="text" maxlength="25" formControlName="expedienteConsorcio">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
            <mat-label>Ayuda adicional</mat-label>
            <select matNativeControl formControlName="adicional">
              <option value="NO">No</option>
              <option value="TAXI/VTC" *ngIf="tipoAyuda=='AYUDA MOVES'">Taxi/VTC</option>
              <option value="PERSONA CON DISCAPACIDAD/MOVILIDAD REDUCIDA">Persona con discapacidad/Movilidad reducida</option>
              <option value="EMPADRONADA EN UN MUNICIPIO DE MENOS DE 5.000 HABITANTES" *ngIf="tipoAyuda=='AYUDA MOVES'">Empadronada en un municipio de menos de 5.000 habitantes</option>
            </select>
          </mat-form-field>
          <mat-form-field class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
            <mat-label>Modelo eléctrico (Base de datos IDAE)</mat-label>
            <input type="text"
                   placeholder="Seleccione modelo"
                   aria-label="Number"
                   matInput
                   [formControl]="marcaModelo"
                   [matAutocomplete]="auto"
                   (input)="getMarcaModelo()"
                   [matTooltip]="marcaModelo.value"
                   [class.is-invalid]="faltaMarcaModelo">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event)">
                <mat-option [value]="option" *ngFor="let option of options" matTooltip={{option.Modelo}}>{{option.Modelo}}</mat-option>
            </mat-autocomplete>
            <small *ngIf="faltaMarcaModelo" style="color: red;">
              Marca y modelo son <strong>requeridos</strong>
            </small>
          </mat-form-field>
          <!--
          <p *ngIf="faltaMarcaModelo" class="text-center" style="color: red;">
            *Marca y modelo son obligatorios.
          </p>
          -->
          <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
            <mat-label>Autonomía KM eléctrico (Base de datos IDAE)</mat-label>
            <input matInput matNativeControl type="number" maxlength="15" formControlName="autonomiaKm">
          </mat-form-field>
          <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V' || tipoAyudaSigla=='P'">
            <mat-label>Potencia Kwh (Base de datos IDAE)</mat-label>
            <input matInput matNativeControl type="number" maxlength="15" formControlName="potenciaKwh">
          </mat-form-field>
          

        <mat-form-field appearance="outline" class="col-lg-2 col-md-2 col-sm-12 col-2" *ngIf="tipoAyudaSigla=='V'">
          <mat-label>Vehículo de demostración</mat-label>
          <select matInput matNativeControl formControlName="demo">
            <option value=0>No</option>
            <option value=1>Si</option>
          </select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-2 col-md-2 col-sm-12 col-2" *ngIf="tipoAyuda!='AYUDA MOVES'">
          <mat-label>Vehículo nuevo/seminuevo</mat-label>
          <select matInput matNativeControl formControlName="vehiculoNuevo">
            <option value=1>Nuevo</option>
            <option value=0>Seminuevo</option>
          </select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="mostrarMinimis">
            <mat-label>Importe ayudas Minimis</mat-label>
            <input matInput matNativeControl type="number" maxlength="15" formControlName="minimis">
          </mat-form-field>
        <!--
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
            <mat-label>Expediente ayuda</mat-label>
            <input matInput matNativeControl type="text" maxlength="15" formControlName="expedienteAyuda">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" >
            <mat-label>Estado ayuda</mat-label>
            <input matInput matNativeControl type="text" maxlength="15" formControlName="estadoAyuda">
        </mat-form-field>
        -->
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="mostrarCif">
          <mat-label>CIF</mat-label>
          <input matInput matNativeControl type="TEXT"  maxlength="9" formControlName="cif">
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="mostrarIAE">
          <mat-label>Epígrafe IAE</mat-label>
          <input matInput matNativeControl type="TEXT" maxlength="15" formControlName="IAE">
        </mat-form-field>

        

        <mat-form-field appearance="outline" class="col-lg-2 col-md-2 col-sm-12 col-2" *ngIf="tipoAyudaSigla=='V' || tipoAyuda!='AYUDA MOVES'">
            <mat-label>Achatarra un vehículo</mat-label>
            <select matInput matNativeControl formControlName="achatarra" (ngModelChange)="getAchatarra($event)">
              <option value=0 *ngIf="tipoAyuda=='AYUDA MOVES'">No</option>
              <option value=1 *ngIf="tipoAyuda=='AYUDA MOVES'">Si</option>
              <option value=1 *ngIf="tipoAyuda!='AYUDA MOVES'" selected>Si</option>
              
            </select>
          </mat-form-field>
          <mat-form-field  class="col-lg-2 col-md-4 col-sm-12" appearance="standard" *ngIf="achatarra || tipoAyuda!='AYUDA MOVES'">
            <mat-label>Fecha matriculación vehículo achatarrado</mat-label>
            <input matInput [matDatepicker]="picker1" formControlName="fechaAchatarrado" matTooltip="Seleccione la fecha en la que se matriculó el vehículo achatarrado">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="achatarra || tipoAyuda!='AYUDA MOVES'">
            <mat-label>Matrícula vehículo achatarrado</mat-label>
            <input matInput matNativeControl type="text" maxlength="15" formControlName="matriculaAchatarrado">
          </mat-form-field>
          <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="achatarra || tipoAyuda!='AYUDA MOVES'">
            <mat-label>Marca vehículo achatarrado</mat-label>
            <input matInput matNativeControl type="text" maxlength="15" formControlName="marcaAchatarrado">
          </mat-form-field>
          <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="achatarra || tipoAyuda!='AYUDA MOVES'">
            <mat-label>Modelo vehículo achatarrado</mat-label>
            <input matInput matNativeControl type="text" maxlength="15" formControlName="modeloAchatarrado">
          </mat-form-field>
      <div class="row" style="margin-left: 15px" *ngIf="tipoAyudaSigla=='P'">
          <mat-form-field  class="col" appearance="standard">
            <mat-label>Fecha de inicio del proyecto</mat-label>
            <input matInput [matDatepicker]="picker2" formControlName="fechaInicioProyecto" matTooltip="Seleccione la fecha de inicio del proyecto">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
        <mat-form-field  class="col" appearance="standard">
            <mat-label>Fecha de fin del proyecto</mat-label>
            <input matInput [matDatepicker]="picker3" formControlName="fechaFinalProyecto" matTooltip="Seleccione la fecha de finalización del proyecto">
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="col">
            <mat-label>Reducción de emisiones</mat-label>
            <input matInput matNativeControl type="number" maxlength="10" formControlName="reduccionEmisiones">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col">
            <mat-label>Ahorro energético</mat-label>
            <input matInput matNativeControl type="number" maxlength="15" formControlName="ahorroEnergetico">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col">
            <mat-label>Tipo de instalación</mat-label>
            <input matInput matNativeControl type="text" maxlength="15" formControlName="tipoInstalacion">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col">
            <mat-label>Número de conectores</mat-label>
            <input matInput matNativeControl type="text" maxlength="15" formControlName="numeroConectores">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col">
            <mat-label>Tipo de conector</mat-label>
            <input matInput matNativeControl type="text" maxlength="15" formControlName="tipoConector">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col">
            <mat-label>Inversión total</mat-label>
            <input matInput matNativeControl type="number" maxlength="15" formControlName="inversionTotal">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col">
            <mat-label>Marca y modelo del cargador</mat-label>
            <input matInput matNativeControl type="text" maxlength="15" formControlName="marcaModeloCargador">
        </mat-form-field>  
    </div>     
      <div class="row mt-2">
        <div class="col-6 text-right">
          <button mat-button class="btn-danger" matStepperPrevious>Atras</button>
        </div>

        <div class="col-6 text-left">
          <button mat-button type="submit" class="btn-info" [disabled]="faltaMarcaModelo && tipoAyudaSigla=='V'" matStepperNext>Siguiente</button>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="datosVehiculos" [editable]="isEditable">
    <ng-template matStepLabel>Vehículo</ng-template>
    <h3 class="text-left" style="color: #5a1727" *ngIf="tipoAyudaSigla!='V' && tipoAyuda=='AYUDA MOVES'">No se requieren datos de vehículo.</h3>
    <form
      [formGroup]="datosVehiculos"
      autocomplete="off"
      (ngSubmit)="siguiente()"
      
    >
      <h3 class="text-left" style="color: #5a1727" *ngIf="tipoAyudaSigla=='V'">Datos Vehículos</h3>
      <hr />

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V' || tipoAyuda!='AYUDA MOVES'">
        <mat-label>Matrícula(A)</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          maxlength="10"
          [class.is-invalid]="matriculaNoValido"
          formControlName="matricula"
          (input)="getVehiculo()"
          (change)="checkRequired()"
        />
        <small *ngIf="matriculaNoValido">
          La matrícula es <strong>requerida</strong>
        </small>
      </mat-form-field>
      <div class="input-group">
        <mat-form-field
          appearance="outline"
          class="col-lg-3 col-md-6 col-sm-12"
          *ngIf="tipoAyudaSigla=='V' || tipoAyuda!='AYUDA MOVES'"
        >
          <mat-label>Nº Bastidor (E)</mat-label>
          <input
            matInput
            matNativeControl
            type="text"
            maxlength="30"
            [class.is-invalid]="bastidorNoValido"
            formControlName="bastidor"
            onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)"
            maxlength="17"
          />
          <small *ngIf="bastidorNoValido">
            El numero de Bastidor es <strong>requerido</strong>
          </small>
        </mat-form-field>
        <div class="input-group-btn" *ngIf="tipoAyudaSigla=='V'">
          <button
            mat-button
            class="btn btn-secondary"
            style="vertical-align: middle; margin-top: 6px"
            (click)="getDatosEITV()"
            matTooltip="Presione para recuperar los datos del vehículo desde la DGT"
          >
          <mat-icon>directions_car</mat-icon>&nbsp;Recuperar datos técnicos de DGT
          </button>
        </div>
      </div>
      <div *ngIf="recuperadoEITV">
        <!--<mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
            <mat-label>Nº Bastidor(E)</mat-label>
            <input matInput matNativeControl type="text" [class.is-invalid]="bastidorNoValido"
                formControlName="bastidor" onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)" maxlength="17">
            <small *ngIf="bastidorNoValido">
            El numero de Bastidor es <strong>requerido</strong>
            </small>
        </mat-form-field>-->
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
            <mat-label>Marca(D.1)</mat-label>
            <input
            matInput
            matNativeControl
            type="text"
            maxlength="45"
            [class.is-invalid]="marcaNoValido"
            formControlName="marca"
            />
            <small *ngIf="marcaNoValido">
            La marca es <strong>requerida</strong>
            </small>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
            <mat-label>Modelo(D.3)</mat-label>
            <input
            matInput
            matNativeControl
            type="text"
            maxlength="50"
            [class.is-invalid]="modeloNoValido"
            formControlName="modelo"
            />
            <small *ngIf="modeloNoValido">
            El modelo es <strong>requerido</strong>
            </small>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
            <mat-label>Clasificación</mat-label>
            <select matInput matNativeControl formControlName="tipoVehiculo">
            <option label="--Seleccionar--"></option>
            <option value="03">03xx – CICLOMOTOR</option>
            <option value="04">04xx – MOTOCICLETA</option>
            <option value="06">06xx – AUTOMÓVIL DE TRES RUEDAS</option>
            <option value="10">10xx – TURISMO</option>
            <option value="17">17xx – PICK UP</option>
            <option value="20">20xx – CAMIÓN MMA ≤3.500 kg</option>
            <option value="21">21xx – CAMIÓN 3.500 kg. < MMA ≤ 12.500 kg</option>
            <option value="22">22xx – CAMIÓN MMA > 12.000 kg</option>
            <option value="24">24xx – FURGÓN/FURGONETA MMA ≤ 3.500 kg</option>
            <option value="31">31xx – VEHICULO MIXTO ADAPTABLE</option>
            <option value="32">32xx – AUTO-CARAVANA MMA ≤ 3.500 kg</option>
            <option value="33">33xx – AUTO-CARAVANA MMA > 3.500 kg</option>
            <option value="66">66xx – QUAD ATV</option>
            </select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
            <mat-label>Cilindrada(P.1)</mat-label>
            <input
            matInput
            matNativeControl
            type="text"
            maxlength="6"
            formControlName="cilindrada"
            />
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
            <mat-label>Potencia Fiscal(P.2.1)</mat-label>
            <input
            matInput
            matNativeControl
            type="text"
            maxlength="50"
            formControlName="potenciaFiscal"
            />
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
            <mat-label>CV(P.2)</mat-label>
            <input matInput matNativeControl type="number" formControlName="cv" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V'">
            <mat-label>CO2(V.7)</mat-label>
            <input
            matInput
            matNativeControl
            type="number"
            maxlength="25"
            formControlName="co2"
            />
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12"  *ngIf="esMoves" (change)="checkRequired()">
          <mat-label>Base Imponible</mat-label>
          <input matInput matNativeControl type="number"  maxlength="14" formControlName="baseImponible">
        </mat-form-field>
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12" *ngIf="tipoAyudaSigla=='V' || tipoAyuda!='AYUDA MOVES'">
            <mat-label>Fecha Matriculación(I)</mat-label>
            <input
            matInput
            [matDatepicker]="picker"
            placeholder="{{ hoy.toLocaleDateString() }}"
            formControlName="fechaMatriculacion"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        </div>
      <div class="row mt-2">
        <div class="col-6 text-right">
          <button mat-button class="btn-danger" matStepperPrevious>Atras</button>
        </div>

        <div class="col-6 text-left">
          <button mat-button type="submit" class="btn-info" matStepperNext *ngIf="recuperadoEITV" [disabled]="!requeridosOK && tipoAyudaSigla=='V'">Siguiente</button>
        </div>
      </div>
    </form>
    
  </mat-step>

  <mat-step [stepControl]="documentos" [editable]="isEditable">
    <ng-template matStepLabel>Documentos</ng-template>
    <app-documentos [datoTramite]="datoTramite"></app-documentos>
  </mat-step>
</mat-horizontal-stepper>

<div *ngIf="spinnerFirma" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
  <h4  style="margin-top: 200px; color: white">Enviando datos para la firma de documentos...</h4>
</div>
<div *ngIf="spinnerEITV" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
  <h4  style="margin-top: 200px; color: white">Conectando con la DGT...</h4>
</div>